import React from 'react';
import CustomModal from '../../components-library/CustomModal';
import { MODAL_SIZES } from '../../services/exports/Constants';
import useOffersStuff from '../../features/offers/hooks/useOffersStuff';
import CloseCircleIcon from '../../assets/icons/CloseCircleIcon';
import useAppMethods from '../../hooks/utility/useAppMethods';
import useAppState from '../../hooks/global/useAppState';
import useOffersTranslations from '../../features/offers/hooks/useOffersTranslations';
import { useTranslation } from 'react-i18next';

const EligibleOffersModal = () => {
  const { toggleEligibleOffersModal } = useAppMethods();
  const { openModal } = useAppState().eligibleOffersModalProps;
  const { eligibleOffers } = useOffersStuff();
  const { t } = useTranslation(null, { keyPrefix: 'Modals:EligibleOffersModal' });
  const { getLabelByOffer } = useOffersTranslations();
  const toggleModal = () => toggleEligibleOffersModal({ openModal: false });

  return (
    <CustomModal
      open={openModal}
      position="center"
      zIndex={5000}
      size={MODAL_SIZES.XS}
      wrapperClassName="flex flex-col p-lg space-y-lg"
      onClose={toggleModal}
    >
      <div className="flex items-center">
        <h3 className="text-md"> {t('title')}</h3>
        <button className="ml-auto" onClick={toggleModal}>
          <CloseCircleIcon />
        </button>
      </div>
      {eligibleOffers.map((offer) => (
        <p key={offer.id} className="space-x-md px-md">
          {getLabelByOffer(offer)}
        </p>
      ))}
    </CustomModal>
  );
};

export default EligibleOffersModal;
